import getFiltersOption from '../store/store';
import { mutator } from 'satcheljs';
import { setBlockContentFromUnknownSenders } from '../actions/internalActions';

mutator(setBlockContentFromUnknownSenders, actionMessage => {
    const filtersOption = getFiltersOption();
    filtersOption.blockContentFromUnknownSenders = actionMessage.blockContentFromUnknownSenders;
});
